import Page from "webPage/Page";
import RegionModal from "modal/RegionModal";
import ScriptHelper from "base/ScriptHelper";
import {TimelineMax, TweenMax} from "gsap";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {registerScene, sectionGetHeight} from "util/parallax";

Page.register('page-template-contact', () => {
    $('body').on('click', '.js-region-modal', function () {
        (new RegionModal($(this))).show();
        return false;
    });

    if ($('.js-map').length > 0) {
        loadGoogleMap($('.js-map'));
    }

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-breadcrumb',
    //     duration: sectionGetHeight('.js-parallax-breadcrumb'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-breadcrumb-circle', 1, {yPercent: -5}, {yPercent: 20}),
    //     TweenMax.fromTo('.js-breadcrumb-circle-2', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-regions',
    //     duration: sectionGetHeight('.js-parallax-regions'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-regions-circle', 1, {yPercent: -5}, {yPercent: 20}),
    //     TweenMax.fromTo('.js-regions-circle-2', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
});

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyAIj-HqlIJVoDUdPWEkTsCmyfD2ZzW3LYE").then(() => {
        loadMap($element);
    });
}

function loadMap($element) {

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: $element.data('zoom') || 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let $markers = $element.find('.js-marker');

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    $markers.each((function () {
        initMarker($(this), map);
    }));

    centerMap(map);
}

function initMarker($marker, map) {
    let latLng = {
        lat: parseFloat($marker.data('lat')),
        lng: parseFloat($marker.data('lng'))
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: {
            url: '/wp-content/themes/avery-berkel-core/images/svg/map-marker.svg',
            scaledSize: new google.maps.Size(56, 74),
            labelOrigin: new google.maps.Point(28, 74),
        }
    });

    map.markers.push(marker);
}

function centerMap(map) {

    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

const MAP_STYLES = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#F5F5F5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#F5F5F5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#BDBDBD"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#EEEEEE"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#E5E5E5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#FFFFFF"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#DADADA"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#E5E5E5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#EEEEEE"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#C9C9C9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E"
            }
        ]
    }
];